import React, { useState } from 'react';

import { SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import Input from 'components/lib/Input';
import { useAppSelector } from 'store/hook';
import { CommunityType } from 'types/communities';

import { OVERALL_VIEW_ID, OVERALL_VIEW_KEY } from './constants';
import RecommendationDetailsSidebarItem from './RecommendationDetailsSidebarItem';
import useRecommendationsContext from './RecommendationsContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

const ScrollContainer = styled.div`
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;

const InputWrapper = styled.div`
  padding: 10px;
  border-bottom: 1px solid var(--line-gray);
`;

const RecommendationDetailsSidebar = () => {
  const { communities } = useAppSelector((state) => state.global);
  const { company } = useRecommendationsContext();
  const [searchQuery, setSearchQuery] = useState('');

  const handleChange = (event: any) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const filteredCommunities = (communities ?? []).filter(
    (item: CommunityType) => item.company_id == company?.id && item.comunity_name.toLowerCase().includes(searchQuery)
  );

  return (
    <Container>
      <InputWrapper>
        <Input
          value={searchQuery}
          prefix={<SearchOutlined />}
          style={{ width: '100%' }}
          onChange={handleChange}
          placeholder="Search communities"
        />
      </InputWrapper>
      <RecommendationDetailsSidebarItem
        key={OVERALL_VIEW_KEY}
        id={OVERALL_VIEW_ID}
        to={`/community`}
        label="Overall"
        iconSrc="/icons/ai-blob.svg"
        description="Company-wide summary"
        isOverallView={true}
      />
      <ScrollContainer className="mini-scroll">
        {filteredCommunities.map((item) => (
          <RecommendationDetailsSidebarItem
            key={item.id}
            id={item.id}
            to={`/community`}
            label={item.comunity_name}
            description={item.address}
          />
        ))}
      </ScrollContainer>
    </Container>
  );
};

export default RecommendationDetailsSidebar;
